<template>
  <!--公共组件，加载时展示图片及数据-->
  <div class="">
    <div class="tips">
      <img src="../../assets/img/nodata.png" alt="">
      <p>暂无数据</p>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.tips {
  padding-top: 36.21%;
  background-color: #fff;
  font-size: 0.375rem;
  display: inline-block;
  width: 100%;
  text-align: center;
  color: #5483D2;
  font-size: 0.4375rem;
}
.tips img {
  width: 5.28125rem;
}
</style>



// WEBPACK FOOTER //
// src/components/public/nodata.vue